import { useCallback, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { Icon, Spinner } from 'components';
import { useCandidateProfile } from 'lib/contexts/candidate-profile-context';
import FloatingCVModal from './FloatingCVModal';

import styles from './FloatingCVSection.module.scss';

export const FloatingCVSection = ({ scrolled }: { scrolled: boolean }) => {
  const [isCVModalOpen, setCVModalOpen] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [t] = useTranslation('candidate.profile');
  const { generateCV } = useCandidateProfile();

  const openCVModal = useCallback(() => {
    setCVModalOpen(true);
  }, []);

  const closeCVModal = useCallback(() => {
    setCVModalOpen(false);
  }, []);

  const downloadCV = async () => {
    setIsDownloading(true);
    await generateCV();
    setIsDownloading(false);
  };

  return (
    <>
      <article className={styles.container}>
        <section className={styles['generate-cv-content']}>
          {isDownloading ? (
            <Spinner className={styles.spinner} color={'secondary'} />
          ) : (
            <div className={styles['download-cv']} onClick={downloadCV}>
              <Icon iconName="icon_magic-wand" size="mediumplus" />
              {!scrolled && (
                <p className={styles.text}>
                  {t('floating-cv-section.generate-cv')}
                </p>
              )}
            </div>
          )}
          <div className={styles.divider}></div>
        </section>
        <div onClick={openCVModal}>
          <Icon
            iconName="icon_ellipsis"
            size="mediumplus"
            className={styles['ellipsis']}
          />
        </div>
      </article>
      {isCVModalOpen && (
        <FloatingCVModal isOpen={isCVModalOpen} onClose={closeCVModal} />
      )}
    </>
  );
};
